import {useContext} from "react"
import { ProjetContext } from "./context"

export function useProjetHook() {
    return useContext(ProjetContext)
}